// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.ReferenceFilterOperation
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let ReferenceFilterOperation = /*#__PURE__*/function (ReferenceFilterOperation) {
  ReferenceFilterOperation[ReferenceFilterOperation["None"] = 0] = "None";
  ReferenceFilterOperation[ReferenceFilterOperation["Contains"] = 1] = "Contains";
  ReferenceFilterOperation[ReferenceFilterOperation["Matches"] = 2] = "Matches";
  ReferenceFilterOperation[ReferenceFilterOperation["StartsWith"] = 3] = "StartsWith";
  ReferenceFilterOperation[ReferenceFilterOperation["EndsWith"] = 4] = "EndsWith";
  ReferenceFilterOperation[ReferenceFilterOperation["Object"] = 5] = "Object";
  ReferenceFilterOperation[ReferenceFilterOperation["Specified"] = 6] = "Specified";
  return ReferenceFilterOperation;
}({});
(function (_ReferenceFilterOperation) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? ReferenceFilterOperation[enumVal] != null ? enumVal : undefined : ReferenceFilterOperation[enumVal];
  }
  _ReferenceFilterOperation.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _ReferenceFilterOperation.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _ReferenceFilterOperation.indexOf = indexOf;
})(ReferenceFilterOperation || (ReferenceFilterOperation = {}));
//# sourceMappingURL=ReferenceFilterOperation.js.map
